export enum ChangeLevel {
    Low = 0,
    Medium = 1,
    High = 2,
    Urgent = 3,
}

export enum ChangeStatus {
    Closed = 0,
    Open = 1,
    OnHold = 3,
    AwaitingApproval = 4,
    InProgress = 5,
    Testing = 6,
}

export interface Change {
    change_id: number;
    created_at: string;
    requester: string;
    approver: string;
    title: string;
    description: string;
    status: ChangeStatus;
    priority: ChangeLevel;
    impact: ChangeLevel;
    risk: ChangeLevel;
    implementation_date: string;
    requires_downtime: boolean;
}

export function getChangeStatusLabel(status: ChangeStatus): string {
    switch (status) {
        case ChangeStatus.Closed:
            return "Closed";
        case ChangeStatus.Open:
            return "Open";
        case ChangeStatus.OnHold:
            return "On Hold";
        case ChangeStatus.AwaitingApproval:
            return "Awaiting Approval";
        case ChangeStatus.InProgress:
            return "In Progress";
        case ChangeStatus.Testing:
            return "Testing";
        default:
            return "NULL";
    }
}

export function getChangeLevelLabel(status: ChangeLevel): string {
    switch (status) {
        case ChangeLevel.Low:
            return "Low";
        case ChangeLevel.Medium:
            return "Medium";
        case ChangeLevel.High:
            return "High";
        case ChangeLevel.Urgent:
            return "Urgent";
        default:
            return "NULL";
    }
}